import React, { FunctionComponent, useState } from 'react';
import Loader from '@justgiving/loading/es/Loading';

import Modal from '../Modal/Modal';

import styles from './CheckoutModal.scss';
import { useTranslation } from 'react-i18next';

type CheckoutModalProps = {
  onClose: () => void;
  url: string;
};

export const CheckoutModal: FunctionComponent<CheckoutModalProps> = ({
  onClose,
  url,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <Modal
      onCloseRequest={onClose}
      className={styles.modal}
      modalTitle={t('checkout.modalTitle')}
      displayCloseButton
      closeOnClickOutsideModal={false}
      closeButtonClassName={styles.modalCloseButton}
    >
      {isLoading && (
        <Loader size="large" colour="grey" className={styles.loader} />
      )}
      <iframe
        title={t('checkout.title')}
        src={url}
        className={styles.iframe}
        allow="payment *"
        onLoad={() => setIsLoading(false)}
      ></iframe>
    </Modal>
  );
};
